<template>
	<div>
		<h2
			class="capitalize text-center text-2xl lg:text-4xl font-bold text-slate-950 first-letter:uppercase lg:mt-14"
		>
			{{
			
					getTranslations("discover tailored solutions for your industry")
			
			}}
		</h2>
		<h3
			class="capitalize mt-5 mb-12 text-center md:w-149 md:text-balance mx-auto text-base text-slate-950/70 first-letter:uppercase max-w-lg md:max-w-3xl"
		>
			{{
	
					getTranslations(
						"start by choosing your industry to explore tailored solutions designed to optimize efficiency, enhance safety, and ensure compliance.",
					)
			}}
		</h3>

		<CategoryGrid :categories="categories" />
	</div>
</template>

<script>
import { CategoryGrid } from "@/components/ui";

export default {
	name: "HomeMenu",
	components: {
		CategoryGrid,
	},
	props: {
		categories: {
			type: Array,
			required: true,
		},
		getTranslations: {
			type: Function,
			required: true,
		},
		toTitleCase: {
			type: Function,
			required: true,
		},
	},
};
</script>
